import { Pipe, PipeTransform } from '@angular/core';
import { TestStatus } from '../services/api.service';

/**
 * Pipe to return a status color class for test/exam status values.
 * Usage: {{ status | testStatusBadgeClass }}
 */
@Pipe({
  name: 'testStatusBadgeClass',
  standalone: false,
})
export class TestStatusBadgePipe implements PipeTransform {
  transform(status: TestStatus): string {
    switch (status) {
      case TestStatus.Passed:
        return 'badge text-bg-success';
      case TestStatus.Failed:
        return 'badge text-bg-danger';
      case TestStatus.Taken:
        return 'badge text-bg-info';
      case TestStatus.Incomplete:
        return 'badge text-bg-secondary';
      default:
        return '';
    }
  }
}
